import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';

export const FeatureNotAvailable: React.FC = (): React.ReactElement => {
  const tr = useTranslator();

  return (
    <Paper sx={styles.container}>
      <Box width={400}>
        <Typography variant="h6" color="custom.LightGray" gutterBottom={true}>
          {tr('FEATURE_NOT_AVAILABLE_TITLE')}
        </Typography>
        <Typography color="custom.LightGray">{tr('FEATURE_NOT_AVAILABLE_DESCRIPTION')}</Typography>
      </Box>
    </Paper>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    p: 4,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    mr: 'auto',
    height: '100%',
  },
};
